import { useContext } from 'react';
import { TherapyFilter } from './TherapyFilter';
import { SuppliersContext } from 'Context/SuppliersContext';

export const DynamicAdvancedFilter = () => {
  const { suppliersId } = useContext(SuppliersContext);

  switch (suppliersId) {
    case 0: {
      return <TherapyFilter />;
    }
    default:
      return null;
  }
};
